module.exports = __webpack_public_path__ + "img/logo-light.b2fcf22c.png";